<template>
  <div class="routeList">
    <span
      v-for="item in routeList"
      :key="item.path"
      class="cursor-pointer"
      :class="{ active: $route.path === item.path }"
      @click="goRoute(item)"
      >{{ item.name }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'pageRoute',
  components: {},
  data () {
    return {
      routeList: [
        {
          name: '首页',
          path: '/'
        },
        {
          name: '设计选型',
          path: '/meterSelectionIndex'
        },
        {
          name: '产品选型',
          path: '/selectionCategoryList'
        },
        {
          name: '场景选型',
          path: '/sceneSelectionHome'
        }
      ]
    }
  },
  created () {
    const isShow = localStorage.getItem('sceneSelectionHome')
    if (isShow === '0') {
      // 隐藏
      const sceneSelectionIndex = this.routeList.findIndex(
        (item) => item.name === '场景选型'
      )
      if (sceneSelectionIndex >= 0) {
        this.routeList.splice(sceneSelectionIndex, 1)
      }
    }
  },
  mounted () {
    // 如果场景选型内容为空 则隐藏入口
    // 场景选型序号，用于删除
    const sceneSelectionIndex = this.routeList.findIndex(
      (item) => item.name === '场景选型'
    )
    this.$http
      .post(
        `/front/cross/commodity-user/queryPage`,
        {
          limit: 20,
          page: 1,
          statusList: ['1']
        },
        {
          noMessage: true
        }
      )
      .then(async ({ data: res }) => {
        if (
          !(res.code === 0 && res.data.dataList && res.data.dataList.length > 0)
        ) {
          if (sceneSelectionIndex >= 0) {
            this.routeList.splice(sceneSelectionIndex, 1)
          }
          if (this.$route.name === 'sceneSelectionHome') {
            this.$router.push({
              path: '/meterSelectionIndex'
            })
          }
          localStorage.setItem('sceneSelectionHome', '0')
        } else {
          if (sceneSelectionIndex === -1) {
            this.routeList.push({
              name: '场景选型',
              path: '/sceneSelectionHome'
            })
          }
          // 是否显示场景选型
          localStorage.setItem('sceneSelectionHome', '1')
        }
      })
      .catch(() => {
        if (sceneSelectionIndex >= 0) {
          this.routeList.splice(sceneSelectionIndex, 1)
        }
        if (this.$route.name === 'sceneSelectionHome') {
          this.$router.push({
            path: '/meterSelectionIndex'
          })
        }
        localStorage.setItem('sceneSelectionHome', '0')
      })
  },
  methods: {
    goRoute (item) {
      if (this.$route.path === item.path) return
      this.$router.push({ path: item.path })
    }
  }
}
</script>
<style lang="scss" scoped>
.routeList {
  margin-top: 16px;
  margin-bottom: 16px;
  // text-align: center;
  span {
    font-family: Alibaba PuHuiTi;
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
    line-height: 16px;
    color: #333;
    padding: 8px 16px;
    display: inline-block;
    // transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    &.active {
      color: #2a54d1;
      background: #f5f6fa;
      // border-radius: 8px;
    }
    &:hover {
      color: #2a54d1;
      background: #f5f6fa;
      // border-radius: 8px;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
